const missionPillars = [
  {
    icon: 'ri-compasses-2-line',
    title: 'Strategic Consultancy',
    desc: 'Guiding organizations through AI integration and digital transformation with expert strategic planning and precision implementation support',
  },
  {
    icon: 'ri-cpu-line',
    title: 'Intelligent Systems',
    desc: 'Empowering responsible adoption of AI technologies across industries to enhance operational efficiency and accelerate breakthrough innovation',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Digital Wellbeing',
    desc: 'Advancing digital health initiatives through evidence-based science and strategic implementation that puts human potential first',
  },
];

export default function MissionSection() {
  return (
    <section className="py-24" style={{ background: 'linear-gradient(180deg, #0d0d1a 0%, #09090f 100%)' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase mb-4" style={{ color: '#c9a84c' }}>
            Our Mission
          </span>
          <h2 className="text-4xl font-bold text-white mb-8 tracking-tight">
            Why{' '}
            <span style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>
              Éclat-Gen
            </span>{' '}
            Exists
          </h2>
          <div
            className="relative max-w-4xl mx-auto p-8 md:p-12"
            style={{ background: 'rgba(201,168,76,0.04)', border: '1px solid rgba(201,168,76,0.15)', borderRadius: '12px' }}
          >
            <i className="ri-double-quotes-l absolute top-6 left-6 text-4xl opacity-20" style={{ color: '#c9a84c' }} />
            <blockquote className="text-xl md:text-2xl font-light text-white/75 leading-relaxed italic">
              Éclat-Gen delivers strategic consultancy and technical support to help organizations harness artificial intelligence and digital transformation. We empower clients across industries to enhance operational efficiency, accelerate innovation, and advance digital health initiatives. Our mission is to engineer brilliance — because living and performing at your peak is not a luxury, it&apos;s a science.
            </blockquote>
            <i className="ri-double-quotes-r absolute bottom-6 right-6 text-4xl opacity-20" style={{ color: '#c9a84c' }} />
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {missionPillars.map((p, i) => (
            <div
              key={p.title}
              className="text-center p-8 transition-all duration-300"
              style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(201,168,76,0.12)', borderRadius: '12px' }}
            >
              <div
                className="w-14 h-14 flex items-center justify-center mx-auto mb-5"
                style={{ background: `rgba(201,168,76,${0.08 + i * 0.04})`, border: '1px solid rgba(201,168,76,0.25)', borderRadius: '10px' }}
              >
                <i className={`${p.icon} text-2xl`} style={{ color: '#c9a84c' }} />
              </div>
              <h3 className="text-lg font-semibold text-white/90 mb-3 tracking-wide">{p.title}</h3>
              <p className="text-sm text-white/45 font-light leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
